import { render, staticRenderFns } from "./addRules.vue?vue&type=template&id=57fa7e1c&scoped=true&"
import script from "./addRules.vue?vue&type=script&lang=js&"
export * from "./addRules.vue?vue&type=script&lang=js&"
import style0 from "./addRules.vue?vue&type=style&index=0&id=57fa7e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa7e1c",
  null
  
)

export default component.exports